import { useState } from "react";

/**

 *
 * @returns {{
 *   emailModalOpen: boolean,
 *   selectedJob: { id: number, name: string } | null,
 *   handleViewEmail: (row: object) => void,
 *   closeEmailModal: () => void,
 * }}
 */
export function useEmailDetailModal() {
    const [emailModalOpen, setEmailModalOpen] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);
    const [selectedReportData, setSelectedReportData] = useState(null);

    const handleViewEmail = (row) => {

        setSelectedJob({ id: row.jobId ?? row.id, name: row.jobName ?? row.name });

        setSelectedReportData(row.lastEmail ? row : null);
        setEmailModalOpen(true);
    };

    const closeEmailModal = () => {
        setEmailModalOpen(false);
        setSelectedReportData(null);
    };

    return { emailModalOpen, selectedJob, selectedReportData, handleViewEmail, closeEmailModal };
}
